import Footer from "../../components/homeComponents/Footer";
import classes from "./ResetPassword.module.css";
import logo from "../../assets/icons/Logo_register.png";
import { useRef, useState } from "react";
import axios from "axios";

function ResetPassword() {
  const [changePasswordDone, setChangePasswordDone] = useState(false);
  const [isSend, setIsSend] = useState(false);
  const [hasFailed, setHasFailed] = useState(false);
  const [passIsSame, setPassIsSame] = useState(true);
  const [hasNull, setHasNull] = useState(false);
  const [message, setMessage] = useState("");
  const password = useRef();
  const repeatPassword = useRef();

  const submit = async () => {
    const newPassword = password.current.value;
    const confirmPassword = repeatPassword.current.value;
    let token = localStorage.getItem("token");

    if (!newPassword || !confirmPassword) {
      setHasNull(true);
      return;
    }

    if (newPassword !== confirmPassword) {
      setPassIsSame(false);
      return;
    }

    setHasNull(false);
    setPassIsSame(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/user/changepassword`,
        {
          new_password: newPassword,
          confirm_password: confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setChangePasswordDone(true);
      } else {
        setHasFailed(true);
      }
    } catch (error) {
      setHasFailed(true);
    }
  };

  return (
    <div className={classes.main}>
      <div className={classes.container}>
        <div className={classes.section_logo}>
          <img className={classes.logo_img} alt="Logo" src={logo}></img>
        </div>
        <div className={classes.section_form}>
          <div className={classes.body}>
            <input
              type="password"
              placeholder="رمز عبور جدید"
              className={classes.input}
              ref={password}
              required
              id="name"
            />
            <input
              type="password"
              placeholder="تکرار رمز عبور جدید"
              className={classes.input}
              ref={repeatPassword}
              required
              id="name"
            />

            <div className={classes.buttons_Container}>
              <button className={classes.submitButton} onClick={submit}>
                تغییر رمز عبور
              </button>
            </div>
            <div className={classes.message}>
              {isSend && "کد پیامکی برای شما ارسال شده است"}
              {hasFailed && "پروسه با خطا مواجه شده است"}
              {!passIsSame && "پسورد وارد شده با تکرار آن همخوانی ندارد"}
              {hasNull &&
                "مقادیر مورد نیاز را با دقت پر نموده و مجدد امتحان کنید"}
              {changePasswordDone && "پسورد شما با موفقیت تغییر کرده است"}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ResetPassword;
